module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAUCAIAAACIxBMbAAAAy0lEQVRIx2NkUJjPQBfAOGrTqE2oNoXnHCBVDyvLrz9/Wf//ZyTNpv///5Og/Ndjhn/fv3xn5uFiZGDiZWAVpY1Nfz+++vjy4QOOmyf7tKxLZaQ+iglIMLAI0cCmXw/6Vp1TZzvv4pK4aduq1xwaWf76DKyKNLDpz+uaaYv4mc7wC7PevMsqIWNRGhPAwCJKA5v+fT94cd3pcx84/op8YX5layJurePOwMxPmxTx++nJWxdfv+WXlPhlrKDEwCZP21Q+WkaM2jS0bAIAYx5Y/duCaO8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sv.png
// module id = 933
// module chunks = 0